import { render, staticRenderFns } from "./VEmployerServices.vue?vue&type=template&id=316dc434&lang=pug"
import script from "./VEmployerServices.vue?vue&type=script&lang=ts"
export * from "./VEmployerServices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports